<!-- 协同备注 -->
<template>
  <div class="MarkCooperate">
    <header class="header">
      <div>
        <span class="title">协同备注</span>
        <a-button class="btn" @click="onEdit" type="link" size="small">
          <EditOutlined />
          编辑
        </a-button>
      </div>
      <a-button type="link" class="view-btn" @click="seeFollowupReasons">
        查看完成回访备注
        <RightOutlined />
      </a-button>
    </header>
    <div class="content-footer">
      <div class="noContent" :class="{ content: !!remarkInfoResponse?.beRemarkContent }">
        {{ remarkInfoResponse?.beRemarkContent || '暂无备注' }}
      </div>
      <div v-if="remarkInfoResponse?.remarkTime" class="footer">
        <span class="time">{{ remarkInfoResponse?.remarkTime }}</span>
        <span class="BD">
          {{ remarkInfoResponse?.remarkPersonTypeStr }}-{{ remarkInfoResponse?.remarkPersonName }}
        </span>
      </div>
    </div>
    <a-modal title="协同备注" @cancel="cancelMark" @ok="saveMark" v-model:visible="data.visible">
      <div class="markBox">
        <a-textarea
          v-model:value="data.mark"
          placeholder="请输入"
          :auto-size="{ minRows: 2, maxRows: 6 }"
          :showCount="false"
          :maxlength="200"
          :bordered="false"
          class="textarea"
        />
        <div class="markLen">{{ data.mark.length }}/200</div>
      </div>
    </a-modal>

    <!-- 完成回访备注弹窗 -->
    <CompleteFollowupRemarkModal ref="completeFollowupRemarkRef" />
  </div>
</template>

<script setup>
import { EditOutlined } from '@ant-design/icons-vue'
import { computed, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { updatePatRemark } from '@/api/workPlace/remark'
import CompleteFollowupRemarkModal from './CompleteFollowupRemarkModal.vue'
import { RightOutlined } from '@ant-design/icons-vue'

const store = useStore()
const remarkInfoResponse = computed(() => store.state.patientFile.remarkInfoResponse)
// const patientType = computed(() => store.state.patientFile.patientType)
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const profileInfo = computed(() => store.state.patientFile.bindUser.profileInfo)
const info = computed(() => store.state.patientFile.info)
const userInfo = computed(() => store.state.user.userInfo)
// const hasId = computed(
//   () => info.value.ucPatientId && profileInfo.value.id && doctorInfo.value.ucDoctorId
// )
// const canEdit = computed(() => patientType.value === 0 || hasId.value)
const data = reactive({
  mark: '',
  visible: false
})

// 完成回访备注弹窗
const completeFollowupRemarkRef = ref()

const onEdit = () => {
  data.visible = true
  data.mark = remarkInfoResponse.value.beRemarkContent || ''
}
const saveMark = () => {
  const params = {
    remarkId: userInfo.value.ucUserId,
    remarkPersonType: 2, // 备注人类别：1-BD，2-协同备注/健管,3-医生辅助账号
    beRemarkId: info.value.patientId || info.value.prePatientId, //Get(groupInfo, 'value.patientInfo.businessId', ''),
    beRemarkUcUserId: info.value?.ucPatientId || 0,
    beRemarkContent: data.mark,
    beRemarkType: 3, // 被备注内容类别：1-名称，2-其他，3-协同备注名称
    beRemarkPersonType: 1, // 被备注人类别：1-患者，2-医生
    businessId: doctorInfo.value?.ucDoctorId || 0, //  Get(groupInfo, 'value.doctorInfo.ucUserId'),
    patientProfileId: profileInfo.value?.id || 0 // 就诊人id
  }
  updatePatRemark(params)
    .then(result => {
      store.dispatch('patientFile/getRemark')
      cancelMark()
    })
    .catch(err => {})
}
const cancelMark = () => {
  data.visible = false
  data.mark = ''
}
const seeFollowupReasons = () => {
  completeFollowupRemarkRef.value?.open({
    ucPatientId: info.value?.ucPatientId || 0,
    ucDoctorId: doctorInfo.value?.ucDoctorId || 0
  })
}
</script>

<style lang="scss" scoped>
.MarkCooperate {
  .header {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
    .btn {
      color: #014ea8;
    }
    .view-btn {
      color: #014ea8;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }
  .content-footer {
    border-radius: 4px;
    background: #fafafa;
    padding: 12px;
    .content {
      max-height: 100px;
      overflow: auto;
      color: #333333;
    }
    .noContent {
      font-size: 16px;
      color: rgb(153, 153, 153);
    }
    .footer {
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      color: #b2b2b2;
      .time {
        margin-right: 8px;
      }
    }
  }
}
.markBox {
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px;
  .textarea {
    border: none;
    &:focus {
      box-shadow: none;
    }
  }
  .markLen {
    text-align: right;
    color: #999;
  }
}
</style>
